import React from "react";

export default function Footer() {
  return (
    <footer className="py-8 border-t border-slate-800 text-center text-sm text-slate-500">
      <div>© {new Date().getFullYear()} Cricket Graphics Studio. Broadcast cricket like a pro.</div>
    </footer>
  );
}
